import { Controller } from "@hotwired/stimulus"

// Toast lifetime. Success is transient — it confirms something the user just did
// and can be missed harmlessly. Failure is not: an FBR rejection or a list of
// pre-upload problems is the only copy of that information the user gets, so an
// alert stays on screen until it's dismissed. Pass dismiss-after-value="0" (or
// any value <= 0) for a toast that must be read.
export default class extends Controller {
  static values = { dismissAfter: { type: Number, default: 4000 } }

  connect() {
    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.style.transition = "opacity 0.3s ease, transform 0.3s ease"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-8px)"
    setTimeout(() => this.element.remove(), 300)
  }
}
